import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const saveCopDocument = api(async function saveCopDocument({ codeOfPracticeId, name, url }) {
    return mutate(
        gql`
            mutation SaveCopDocument($codeOfPracticeId: ID!, $name: String!, $url: String!) {
                saveCopDocument(codeOfPracticeId: $codeOfPracticeId, name: $name, url: $url)
            }
        `,
        { codeOfPracticeId, name, url },
        { returns: "saveCopDocument" }
    )
})
